import { RegionShared } from "@1games-ru/region-shared";
import { useCallback, useState } from "react";
import AccountMpProvider from "@/core/data-provider/data-mp/account/account-mp-provider";
import useErrorTranslation from "@/core/helpers/useErrorTranslation";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";

export default function useDeleteCharacter() {
  const tError = useErrorTranslation();
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState<string>("");
  const [isCompleted, setIsCompleted] = useState<null | boolean>(null);

  const deleteHandler = useCallback(
    async (data: typeof RegionShared.Requests.CharacterDestroyRequest) => {
      try {
        setIsPending(true);
        setError("");

        const response = await AccountMpProvider.deleteCharacter(data);

        if (response instanceof RpcMpProviderSuccessResponse) {
          setIsCompleted(true);
        } else {
          setError(tError(response.message));
          setIsCompleted(false);
        }
      } catch ({ message }) {
        setError(tError(message));
        setIsCompleted(false);
      } finally {
        setIsPending(false);
      }
    },
    [],
  );

  return {
    deleteHandler,
    isPending,
    isCompleted,
    error,
  };
}
